const COMPONENT_NAME = "Drawer";
const CLOSE_BUTTON_ID = "drawer-close-btn";
const TITLE_ID = "dialog-title";
const HEADER_ID = "drawer-header";
export {
  CLOSE_BUTTON_ID,
  COMPONENT_NAME,
  HEADER_ID,
  TITLE_ID
};
